import { BillingServiceCharge } from '../../domain/types';
import { apiPaths } from '../../utils/apiPaths';
import { CrudHandler } from '../CrudHandler';
import { mockBillingServiceChargesData } from '../data/adminData';

export const billingServiceChargesHandler = new CrudHandler<BillingServiceCharge>(
  apiPaths.billingServiceCharges(':customerId' as any).base,
  mockBillingServiceChargesData
);
